/**
 * Utility helpers for between-subject survey groups.
 */

export function getGroupLabel(index: number): string {
  return `Group ${String.fromCharCode(65 + index)}`;
}

export function generateGroupLabels(count: number): string[] {
  return Array.from({ length: count }, (_, i) => getGroupLabel(i));
}





